<template>
  <div class="operating-revenue-container" ref="containerRef">
    <div class="input-container">
      <div class="input-area" :class="{ editing: isEditing }">
        <div class="area-title">收入输入区</div>
        <div class="input-row">
          <!-- 收入输入区 -->
          <div class="input-group">
            <label class="input-label">收入类型</label>
            <select v-model="revenueType" class="input-select">
              <option value="revenue">营业收入</option>
              <option value="otherinput">其他收入</option>
            </select>
          </div>
          <div class="input-group" v-if="revenueType === 'revenue'">
            <label class="input-label">产品名称</label>
            <input
              type="text"
              v-model="revenueForm.name"
              class="input-field"
              placeholder="请输入产品名称"
            />
          </div>
          <div class="input-group" v-if="revenueType === 'revenue'">
            <label class="input-label">计量单位</label>
            <input
              type="text"
              v-model="revenueForm.unit"
              class="input-field"
              placeholder="请输入单位"
            />
          </div>
          <div class="input-group">
            <label class="input-label">{{
              revenueType === "revenue" ? "年销量" : "年收入(万元)"
            }}</label>
            <input
              type="number"
              v-model.number="revenueForm.quantity"
              class="input-field"
              :placeholder="
                revenueType === 'revenue' ? '请输入年销量' : '请输入年收入'
              "
            />
          </div>
          <div class="input-group" v-if="revenueType === 'revenue'">
            <label class="input-label">单价(元)</label>
            <input
              type="number"
              v-model.number="revenueForm.unitprice"
              class="input-field"
              placeholder="请输入单价"
            />
          </div>
          <div class="input-group">
            <label class="input-label">销项税率(%)</label>
            <input
              type="number"
              v-model.number="revenueForm.tax"
              class="input-field"
              placeholder="请输入销项税率"
              min="0"
              max="33"
              @blur="validateTaxRate"
            />
          </div>
          <button v-if="!isEditing" class="add-btn" @click="addRevenueItem">
            添加
          </button>
          <template v-else>
            <button
              class="add-btn"
              style="background-color: #67c23a"
              @click="saveEdit"
            >
              修改
            </button>
            <button
              class="add-btn"
              style="background-color: #909399"
              @click="cancelEdit"
            >
              取消
            </button>
          </template>
        </div>
      </div>

      <div class="input-area" :class="{ editing: isEditing }">
        <div class="area-title">参数输入区</div>
        <div class="input-row">
          <!-- 参数输入区 -->
          <div class="input-group">
            <label class="input-label">城建税率(%)</label>
            <input
              type="number"
              v-model.number="taxParams.UMCTax"
              class="input-field"
              placeholder="请输入城建税率"
              min="0.01"
              max="15"
              @change="onTaxParamsChange"
              @blur="onTaxParamsChange"
            />
          </div>
          <div class="input-group">
            <label class="input-label">教育费附加税率(%)</label>
            <input
              type="number"
              v-model.number="taxParams.Educationtax"
              class="input-field"
              placeholder="请输入教育费附加税率"
              min="0.01"
              max="10"
              @change="onTaxParamsChange"
              @blur="onTaxParamsChange"
            />
          </div>
          <div class="input-group">
            <label class="input-label">消费税率(%)</label>
            <input
              type="number"
              v-model.number="taxParams.consumptiontax"
              class="input-field"
              placeholder="请输入消费税率"
              min="0.01"
              max="50"
              @change="onTaxParamsChange"
              @blur="onTaxParamsChange"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="table-wrapper">
      <div class="table-scroll-area">
        <table class="revenue-table">
          <thead>
            <tr>
              <th class="seq-col">序号</th>
              <th class="item-col">项目</th>
              <th class="total-col">合计</th>
              <th
                class="year-col"
                v-for="index in jichu.calculationPeriod"
                :key="'year-header-' + index"
              >
                {{ index }}
              </th>
            </tr>
            <tr>
              <th class="seq-col">-</th>
              <th class="item-col">建设期/运营期</th>
              <th class="total-col">-</th>

              <th
                class="year-col period-type-col"
                :colspan="jichu.constructionPeriod"
              >
                建设期
              </th>
              <th
                class="year-col period-type-col"
                :colspan="jichu.operationPeriod"
              >
                运营期
              </th>
            </tr>
          </thead>
          <tbody>
            <!-- 1. 营业收入合计（建设期/运营期下方） -->
            <tr class="category-row">
              <td class="seq-col">1</td>
              <td class="item-col">营业收入</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.revenue.revenuetotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`revenue-total-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.revenue.revenueByYear[yearIndex])
                }}</span>
              </td>
            </tr>

            <!-- 营业收入产品行（1.1, 1.2等子序号） -->
            <template v-for="(item, index) in jingyingData.revenue.revenuelist">
              <tr :key="'revenue-name-' + item.id" class="detail-row">
                <td class="seq-col">1.{{ index + 1 }}</td>
                <td class="item-col">
                  <div class="product-cell" style="text-align: left">
                    <span
                      class="product-name"
                      :data-product-id="item.id"
                      @mouseenter="showProductDropdown(item, $event)"
                      @mouseleave="startHideDropdown"
                      >{{ item.name }}（{{ item.unitprice }}元/{{
                        item.unit || "单位"
                      }}）</span
                    >
                  </div>
                </td>
                <td class="total-col">{{ formatNumber(item.totalRevenue) }}</td>
                <td
                  class="year-col"
                  v-for="(year, yearIndex) in jichu.calculationPeriod"
                  :key="`revenue-${index}-${yearIndex}`"
                >
                  <span>{{
                    formatNumber(item.revenueByYear[yearIndex] || 0)
                  }}</span>
                </td>
              </tr>
              <tr :key="'revenue-quantity-' + item.id" class="detail-row">
                <td class="seq-col"></td>
                <td class="item-col" style="text-align: left">
                  年销量（{{ item.unit || "单位" }}）
                </td>
                <td class="total-col">
                  {{ formatNumber(item.totalquantity) }}
                </td>
                <td
                  class="year-col"
                  v-for="(year, yearIndex) in jichu.calculationPeriod"
                  :key="`quantity-${index}-${yearIndex}`"
                >
                  <span>{{
                    formatNumber(item.quantityByYear[yearIndex] || 0)
                  }}</span>
                </td>
              </tr>
              <tr :key="'revenue-tax-' + item.id" class="detail-row">
                <td class="seq-col"></td>
                <td class="item-col" style="text-align: left">
                  销项税额{{ formatTaxRate(item.tax) }}
                </td>
                <td class="total-col">{{ formatNumber(item.totalTax) }}</td>
                <td
                  class="year-col"
                  v-for="(year, yearIndex) in jichu.calculationPeriod"
                  :key="`tax-${index}-${yearIndex}`"
                >
                  <span>{{
                    formatNumber(item.taxByYear[yearIndex] || 0)
                  }}</span>
                </td>
              </tr>
            </template>

            <!-- 2. 其他收入 -->
            <tr class="category-row">
              <td class="seq-col">2</td>
              <td
                class="item-col"
                style="text-align: left"
                @mouseenter="showOtherInputDropdown($event)"
                @mouseleave="startHideDropdown"
              >
                其他收入
              </td>
              <td class="total-col">
                {{ formatNumber(jingyingData.otherinput.total) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`otherinput-${yearIndex}`"
              >
                <span>{{
                  formatNumber(
                    jingyingData.otherinput.inputByYear[yearIndex] || 0
                  )
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col" style="text-align: left">
                其他收入税额{{ formatTaxRate(jingyingData.otherinput.tax) }}
              </td>
              <td class="total-col">
                {{ formatNumber(jingyingData.otherinput.taxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`otherinput-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(
                    jingyingData.otherinput.taxByYear[yearIndex] || 0
                  )
                }}</span>
              </td>
            </tr>

            <!-- 3. 总收入 -->
            <tr class="category-row">
              <td class="seq-col">3</td>
              <td class="item-col">总营业收入</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.revenuetotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`total-revenue-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.revenueByYear[yearIndex] || 0)
                }}</span>
              </td>
            </tr>

            <!-- 4. 增值税组 -->
            <tr class="category-row">
              <td class="seq-col">4</td>
              <td class="item-col">增值税</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.valudedtotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`valued-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.valueddedtax[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">销项税合计</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.outputtotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`output-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.outputtaxByYear[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">进项税合计</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.inptotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`input-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.inputtaxByYear[yearIndex] || 0)
                }}</span>
              </td>
            </tr>

            <!-- 5. 附加税组 -->
            <tr class="category-row">
              <td class="seq-col">5</td>
              <td class="item-col">营业税金及附加</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.additionaltax) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`additional-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.additionaltaxByYear[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">消费税</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.consumptiontaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`consumption-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(
                    jingyingData.consumptiontaxByYear[yearIndex] || 0
                  )
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">城建维护税</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.UMCTaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`umc-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.UMCTaxByYear[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
            <tr class="detail-row">
              <td class="seq-col"></td>
              <td class="item-col">教育费附加</td>
              <td class="total-col">
                {{ formatNumber(jingyingData.EducationtaxTotal) }}
              </td>
              <td
                class="year-col"
                v-for="(year, yearIndex) in jichu.calculationPeriod"
                :key="`education-tax-${yearIndex}`"
              >
                <span>{{
                  formatNumber(jingyingData.EducationtaxByYear[yearIndex] || 0)
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div
        v-if="productDropdownVisible"
        class="global-dropdown"
        :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }"
        @mouseenter="cancelHideDropdown"
        @mouseleave="hideDropdown"
      >
        <div class="menu-item" @click="handleProductEdit">修改</div>
        <div
          class="menu-item danger"
          @click="handleProductDelete"
          v-if="currentProduct && currentProduct.type !== 'otherinput'"
        >
          删除
        </div>
      </div>
      <div
        v-if="otherInputDropdownVisible"
        class="global-dropdown"
        :style="{ top: dropdownTop + 'px', left: dropdownLeft + 'px' }"
        @mouseenter="cancelHideDropdown"
        @mouseleave="hideDropdown"
      >
        <div class="menu-item" @click="handleOtherInputEdit">修改</div>
      </div>
    </div>
  </div>
</template>

<script>
import { calculateOperatingRevenue, workingCapital } from "@/utils/comp.js";

export default {
  name: "OperatingRevenue",
  data() {
    return {
      projectData: {},
      jingyingData: {},
      initialized: false,
      storedCalculationPeriod: null,
      storedConstructionPeriod: null,
      revenueType: "revenue",
      containerRef: null,
      revenueForm: {
        name: "",
        unit: "",
        quantity: 0,
        unitprice: 0,
        tax: 17,
      },
      taxParams: {
        UMCTax: 7,
        Educationtax: 3,
        consumptiontax: 0,
      },
      isEditing: false,
      currentEditId: null,
      currentEditType: "revenue",
      productDropdownVisible: false,
      otherInputDropdownVisible: false,
      dropdownTop: 0,
      dropdownLeft: 0,
      currentProduct: null,
      hideTimeout: null,
      vuexUpdateScheduled: false,
      lastUpdateTime: 0,
    };
  },
  computed: {
    // 修复数据获取方式
    revenueData() {
      return (
        this.projectData["营业收入税金及利润"]?.["营业收入及营业税金"] || {}
      );
    },
    otherInput() {
      return this.revenueData.otherinput || {};
    },
    revenueList() {
      return this.revenueData.revenue?.revenuelist || [];
    },
    // 改为计算属性，确保实时获取最新基础数据
    jichu() {
      return this.projectData.基础数据 || {};
    },
    calculationPeriod() {
      return this.jichu.calculationPeriod || 15;
    },
    constructionPeriod() {
      return this.jichu.constructionPeriod || 1;
    },
    operationPeriod() {
      return this.jichu.operationPeriod || 14;
    },
    basicData() {
      return this.jichu;
    },
  },
  created() {
    this.projectData = this.$store.state.projectData || {};
    this.jingyingData =
      this.projectData.营业收入税金及利润?.营业收入及营业税金 ||
      this.getDefaultRevenueData();
  },
  mounted() {
    this.$nextTick(() => {
      this.ensureDataStructure();
      this.initializeData();
      this.recalculateAllData();
    });
  },
  methods: {
    convertTaxRateToPercentage(taxRate, defaultValue) {
      if (taxRate === null || taxRate === undefined) {
        return defaultValue;
      }
      // 如果taxRate是0，返回0
      if (taxRate === 0) {
        return 0;
      }
      // 如果taxRate已经是百分比格式（>= 1），直接返回
      if (taxRate >= 1) {
        return taxRate;
      }
      // 否则转换为百分比格式
      return Math.round(taxRate * 100);
    },

    getDefaultRevenueData() {
      return {
        consumptiontax: 0, //销项税率百分比
        UMCTax: 7, //城建税率百分比
        Educationtax: 3, //教育费附加率百分比
        revenuetotal: 0, //总收入
        revenueByYear: [], //分年收入
        alltax: 0, //总税金
        additionaltax: 0, //附加税
        additionaltaxByYear: [], //分年附加税
        alltaxByYear: [], //各税种分年税金合计
        outputtotal: 0, //总销项税金
        inptotal: 0, //总进项税
        valudedtotal: 0, //总增值税
        UMCTaxTotal: 0, //总城建税
        EducationtaxTotal: 0, //总教育费附加
        consumptiontaxTotal: 0, //总消费税
        outputtaxByYear: [], //分年销项税金
        inputtaxByYear: [], //分年进项税
        valueddedtax: [], //分年增值税
        UMCTaxByYear: [], //分年城建税
        EducationtaxByYear: [], //分年教育费附加
        consumptiontaxByYear: [], //分年消费税

        //营业收入
        revenue: {
          revenueByYear: [], //分年营业收入合计
          revenuetotal: 0, //营业收入合计
          revenuelist: [], //各产品收入明细
        },

        //其他收入
        otherinput: {
          input: 0, //年收入
          tax: 0.17, //其他收入税率百分比
          total: 0, //总其他收入
          taxTotal: 0, //总其他收入税金
          taxByYear: [], //其他收入分年税金
          inputByYear: [], //其他收入分年收入
        },
      };
    },

    ensureDataStructure() {
      // 确保营业收入税金及利润数据结构存在
      if (!this.projectData["营业收入税金及利润"]) {
        this.projectData["营业收入税金及利润"] = {};
      }

      if (!this.projectData["营业收入税金及利润"]["营业收入及营业税金"]) {
        this.projectData["营业收入税金及利润"]["营业收入及营业税金"] =
          this.getDefaultRevenueData();
      }
    },

    initializeData() {
      // 初始化参数 - 保持百分比格式，用于输入框显示
      if (this.jingyingData) {
        this.taxParams.UMCTax = this.convertTaxRateToPercentage(this.jingyingData.UMCTax, 7);
        this.taxParams.Educationtax = this.convertTaxRateToPercentage(this.jingyingData.Educationtax, 3);
        this.taxParams.consumptiontax = this.convertTaxRateToPercentage(this.jingyingData.consumptiontax, 0);
      }

      // 为现有收入项目添加id字段（如果不存在）
      if (this.jingyingData.revenue && this.jingyingData.revenue.revenuelist) {
        this.jingyingData.revenue.revenuelist.forEach((item, index) => {
          if (!item.id) {
            // 为没有id的项目生成唯一id
            item.id = `existing_${Date.now()}_${index}`;
          }
        });
      }

      // 初始化其他收入
      if (this.otherInput) {
        this.revenueForm.quantity = this.otherInput.input || 0;
      }

      this.storedCalculationPeriod = this.calculationPeriod;
      this.storedConstructionPeriod = this.constructionPeriod;
      this.initialized = true;
    },

    handlePageActivation() {
      // 减少页面激活时的数据重置
      this.initialized = false;
      if (
        this.revenueList.length > 0 &&
        (this.storedCalculationPeriod !== this.calculationPeriod ||
          this.storedConstructionPeriod !== this.constructionPeriod)
      ) {
        this.ensureDataStructure();
        this.initializeData();
      }
      this.$nextTick(() => {
        this.initialized = true;
      });
    },

    async addRevenueItem() {
      // 其他收入只需要验证金额和税率
      if (this.revenueType === "otherinput") {
        if (!this.revenueForm.quantity && this.revenueForm.quantity !== 0) {
          this.$message.warning("请输入其他收入金额");
          return;
        }
        if (!this.revenueForm.tax && this.revenueForm.tax !== 0) {
          this.$message.warning("请输入税率");
          return;
        }

        // 更新其他收入数据
        this.jingyingData.otherinput.input = this.revenueForm.quantity;
        this.jingyingData.otherinput.tax = this.revenueForm.tax / 100;
      } else {
        // 营业收入需要验证所有字段
        if (!this.revenueForm.name.trim()) {
          this.$message.warning("请输入产品名称");
          return;
        }
        if (!this.revenueForm.unit.trim()) {
          this.$message.warning("请输入产品单位");
          return;
        }
        if (!this.revenueForm.unitprice) {
          this.$message.warning("请输入单价");
          return;
        }

        const newItem = {
          id: Date.now(),
          type: "revenue", // 添加type字段
          name: this.revenueForm.name,
          unit: this.revenueForm.unit,
          quantity: this.revenueForm.quantity,
          unitprice: this.revenueForm.unitprice,
          tax: this.revenueForm.tax / 100, // 转换为小数
          revenueByYear: [],
          taxByYear: [],
          quantityByYear: [],
          totalRevenue: 0,
          totalTax: 0,
          totalquantity: 0,
        };

        this.jingyingData.revenue.revenuelist.push(newItem);
      }

      this.updateStore();
      this.recalculateAllData();
      // 重置表单
      this.resetForm();
    },

    saveEdit() {
      if (this.currentEditType === "revenue") {
        const index = this.jingyingData.revenue.revenuelist.findIndex(
          (item) => item.id === this.currentEditId
        );
        if (index !== -1) {
          const item = this.jingyingData.revenue.revenuelist[index];
          item.name = this.revenueForm.name;
          item.unit = this.revenueForm.unit;
          item.quantity = this.revenueForm.quantity;
          item.unitprice = this.revenueForm.unitprice;
          item.tax = this.revenueForm.tax / 100;
        }
      } else {
        this.jingyingData.otherinput.input = this.revenueForm.quantity;
        this.jingyingData.otherinput.tax = this.revenueForm.tax / 100;
      }

      // 更新参数
      this.jingyingData.UMCTax = this.taxParams.UMCTax / 100;
      this.jingyingData.Educationtax = this.taxParams.Educationtax / 100;
      this.jingyingData.consumptiontax = this.taxParams.consumptiontax / 100;

      this.updateStore();
      this.recalculateAllData();
      this.cancelEdit();
    },

    cancelEdit() {
      this.isEditing = false;
      this.currentEditId = null;
      this.currentEditType = "revenue";
      this.resetForm();
    },

    resetForm() {
      this.revenueForm = {
        name: "",
        unit: "",
        quantity: 0,
        unitprice: 0,
        tax: 17,
      };
    },

    handleProductEdit() {
      if (!this.currentProduct) return;

      this.isEditing = true;
      this.currentEditId = this.currentProduct.id;
      this.currentEditType =
        this.currentProduct.type === "otherinput" ? "otherinput" : "revenue";

      if (this.currentProduct.type === "otherinput") {
        // 编辑其他收入
        this.revenueForm.quantity = this.jingyingData.otherinput.input || 0;
        this.revenueForm.tax = (this.jingyingData.otherinput.tax || 0.17) * 100;
        this.revenueType = "otherinput";
      } else {
        // 编辑营业收入产品
        this.revenueForm.name = this.currentProduct.name;
        this.revenueForm.unit = this.currentProduct.unit;
        this.revenueForm.quantity = this.currentProduct.quantity;
        this.revenueForm.unitprice = this.currentProduct.unitprice;
        this.revenueForm.tax = this.currentProduct.tax * 100;
        this.revenueType = "revenue";
      }

      this.hideDropdown();
    },

    handleProductDelete() {
      if (!this.currentProduct) {
        console.log("currentProduct is null, cannot delete");
        return;
      }

      console.log("Attempting to delete product:", this.currentProduct);
      console.log(
        "Current revenue list:",
        this.jingyingData.revenue.revenuelist
      );

      // 保存产品信息到局部变量，防止在对话框操作期间被清空
      const productToDelete = { ...this.currentProduct };
      console.log("Saving product for deletion:", productToDelete);

      this.$confirm("确定要删除这个产品吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          console.log("Confirmed deletion, product:", productToDelete);
          const index = this.jingyingData.revenue.revenuelist.findIndex(
            (item) => item.id === productToDelete.id
          );
          console.log("Found index:", index);
          if (index !== -1) {
            this.jingyingData.revenue.revenuelist.splice(index, 1);
            console.log("Product removed from list");
            this.updateStore();
            this.recalculateAllData();
            this.$message.success("产品删除成功");
          } else {
            console.log("Product not found in list");
            this.$message.error("产品未找到");
          }
          this.hideDropdown();
        })
        .catch(() => {
          console.log("Deletion cancelled");
          this.hideDropdown();
        });
    },

    calculateDropdownPosition(event) {
      const rect = event.target.getBoundingClientRect();
      const containerRect = this.$refs.containerRef.getBoundingClientRect();
      return {
        top: rect.bottom,
        left: rect.left,
      };
    },

    showProductDropdown(product, event) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.hideAllDropdowns();
      this.currentProduct = product;
      const pos = this.calculateDropdownPosition(event);
      this.dropdownTop = pos.top;
      this.dropdownLeft = pos.left;
      this.productDropdownVisible = true;
    },

    showOtherInputDropdown(event) {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
      this.hideAllDropdowns();
      const pos = this.calculateDropdownPosition(event);
      this.dropdownTop = pos.top;
      this.dropdownLeft = pos.left;
      this.otherInputDropdownVisible = true;
    },

    hideAllDropdowns() {
      this.productDropdownVisible = false;
      this.otherInputDropdownVisible = false;
    },

    handleOtherInputEdit() {
      this.isEditing = true;
      this.currentEditId = "other-input";
      this.currentEditType = "otherinput";

      this.revenueForm.quantity = this.jingyingData.otherinput.input || 0;
      this.revenueForm.tax = (this.jingyingData.otherinput.tax || 0.17) * 100;
      this.revenueType = "otherinput";

      this.hideDropdown();
    },

    startHideDropdown() {
      this.hideTimeout = setTimeout(() => {
        this.hideDropdown();
      }, 1000); // 增加延迟时间到1000ms，让用户有足够时间点击
    },

    cancelHideDropdown() {
      if (this.hideTimeout) {
        clearTimeout(this.hideTimeout);
        this.hideTimeout = null;
      }
    },

    hideDropdown() {
      this.productDropdownVisible = false;
      this.otherInputDropdownVisible = false; // 添加这行
      // 延迟清空currentProduct，确保删除操作完成
      setTimeout(() => {
        this.currentProduct = null;
      }, 100);
    },

    recalculateAllData() {
      // 确保数据结构存在
      this.ensureDataStructure();

      // 简化税率处理逻辑
      // 1. 税率更改后，先把参数存入VUEX（小数格式）
      // 2. 调用计算函数，计算函数读取VUEX，根据VUEX中的参数，重新计算
      // 3. 将计算结果保存到VUEX，并将计算结果返回组件

      const umcTax = this.taxParams.UMCTax || 7;
      const educationTax = this.taxParams.Educationtax || 3;
      const consumptionTax = this.taxParams.consumptiontax || 0;

      // 更新jingyingData中的税率（百分比格式）
      this.jingyingData.UMCTax = umcTax;
      this.jingyingData.Educationtax = educationTax;
      this.jingyingData.consumptiontax = consumptionTax;

      // 同步税率参数到 projectData 对象（百分比格式）
      if (
        this.projectData["营业收入税金及利润"] &&
        this.projectData["营业收入税金及利润"]["营业收入及营业税金"]
      ) {
        this.projectData["营业收入税金及利润"]["营业收入及营业税金"].UMCTax =
          umcTax;
        this.projectData["营业收入税金及利润"][
          "营业收入及营业税金"
        ].Educationtax = educationTax;
        this.projectData["营业收入税金及利润"][
          "营业收入及营业税金"
        ].consumptiontax = consumptionTax;
      }

      // 更新store
      this.updateStore();

      // 等待DOM更新后再执行计算
      this.$nextTick(() => {
        const result = calculateOperatingRevenue();
        workingCapital();
        
        // 使用返回值更新组件数据
        if (result && result["营业收入税金及利润"]) {
          this.jingyingData = result["营业收入税金及利润"]["营业收入及营业税金"];
        }
      });
    },

    onTaxParamsChange() {
      console.log("税率参数变化，重新计算...", this.taxParams);
      this.recalculateAllData();
    },

    updateStore() {
      // 深拷贝避免引用问题，只更新营业收入税金及利润数据
      const updatedData = JSON.parse(JSON.stringify(this.projectData));
      updatedData["营业收入税金及利润"]["营业收入及营业税金"] = JSON.parse(
        JSON.stringify(this.jingyingData)
      );
      this.$store.commit("SET_PROJECT_DATA", updatedData);
    },

    validateTaxRate() {
      if (this.revenueForm.tax < 0 || this.revenueForm.tax > 33) {
        this.$message.warning("税率应在0-33之间");
        this.revenueForm.tax = Math.max(0, Math.min(33, this.revenueForm.tax));
      }
    },

    formatNumber(value) {
      if (value === null || value === undefined || isNaN(value)) return "";
      if (value === 0) return "";
      return Number(value)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },

    formatTaxRate(rate) {
      if (!rate) return "";
      return `(${Number(rate * 100).toFixed(1)}%)`;
    },
  },
};
</script>

<style scoped>
/* 保持原有样式不变 */
.operating-revenue-container {
  padding: 15px;
  background-color: #f5f7fa;
  /* min-height: 100vh; */
  max-height: 80vh;
  overflow: hidden;
}

/* 输入区域容器 */
.input-container {
  display: flex;
  gap: 15px;
  margin-bottom: 15px;
  height: auto;
}

.input-area {
  /* flex: 1; */
  background-color: white;
  border: 1px solid #e4e7ed;
  border-radius: 6px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.input-row {
  display: flex;
  gap: 12px;
  padding: 15px;
  flex-wrap: wrap;
  align-items: flex-end;
}

.input-group {
  display: flex;
  flex-direction: column;
  min-width: 100px;
  /* flex: 1; */
  max-width: 130px;
}

.input-label {
  font-size: 12px;
  color: #606266;
  margin-bottom: 4px;
  font-weight: 500;
  text-align: left;
  line-height: 1.2;
}

.input-field,
.input-select {
  padding: 6px 8px;
  border: 1px solid #dcdfe6;
  border-radius: 3px;
  font-size: 12px;
  transition: border-color 0.2s;
  height: 32px;
  box-sizing: border-box;
}

.area-title {
  font-size: 12px;
  font-weight: 600;
  color: #303133;
  margin: 10px 20px 15px 20px;
  text-align: left;
  border-bottom: 2px solid #409eff;
  padding-bottom: 8px;
}

.input-select {
  background-color: white;
}

.input-field:focus {
  outline: none;
  border-color: #409eff;
}

.add-btn {
  padding: 10px 24px;
  background-color: #409eff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 15px;
  transition: background-color 0.2s;
}

.add-btn:hover {
  background-color: #66b1ff;
}

/* 表格容器 */
.table-wrapper {
  position: relative;
  width: 99.5%;
  /* height: calc(100vh - 280px); */
  margin: auto;
  min-height: 400px;
  max-height: 600px;
  overflow: hidden;
  background-color: white;
  border: 1px solid #e4e7ed;
  border-radius: 4px;
}

.table-scroll-area {
  width: 100%;
  height: 100%;
  overflow: auto;
  position: relative;
}

.revenue-table {
  width: 100%;
  border-collapse: collapse;
  table-layout: fixed;
  font-size: 12px;
}

.revenue-table th {
  background-color: #f5f7fa;
  border: 1px solid #e4e7ed;
  padding: 6px 3px;
  text-align: center;
  font-weight: 600;
  color: #606266;
  white-space: nowrap;
  font-size: 12px;
}

.revenue-table td {
  border: 1px solid #e4e7ed;
  padding: 4px 3px;
  text-align: center;
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.seq-col {
  width: 35px;
  min-width: 35px;
}

.item-col {
  width: 120px;
  min-width: 120px;
  text-align: left !important;
  padding: 3px 3px !important;
}

.total-col {
  width: 70px;
  min-width: 70px;
}

.year-col {
  width: 45px;
  min-width: 45px;
}

.period-type-col {
  background-color: #f0f9ff;
  color: #409eff;
}

.detail-row td {
  background-color: white;
}

.detail-row td.item-col {
  text-align: left !important;
}

.detail-row:hover {
  background-color: #f8f9fa;
}

.category-row {
  background-color: #f5f7fa;
}

.category-row td {
  font-weight: 600;
  color: #303133;
}

.summary-row {
  background-color: #ecf5ff;
}

.summary-row td {
  font-weight: 600;
  color: #303133;
}

.product-name {
  color: #303133;
  cursor: default;
  text-decoration: none;
  font-weight: normal;
}

.product-name:hover {
  text-decoration: none;
}

.global-dropdown {
  position: fixed;
  background: white;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 10000;
  min-width: 120px;
}

.menu-item {
  padding: 12px 22px;
  cursor: pointer;
  font-size: 15px;
  transition: background-color 0.2s;
}

.menu-item:hover {
  background-color: #f5f7fa;
}

.menu-item.danger {
  color: #f56c6c;
}

.menu-item.danger:hover {
  background-color: #fef0f0;
}

@media (max-width: 768px) {
  .revenue-input-row,
  .params-input-row {
    flex-direction: column;
  }

  .input-group {
    min-width: 100%;
  }

  .revenue-table {
    font-size: 14px;
  }

  .revenue-table th,
  .revenue-table td {
    padding: 8px 4px;
  }
}
</style>
